<template>
  <div class="pg-edit-form-tool">
    <div class="pg-edit-form-tool__menus">
      <i
        class="el-icon-circle-plus-outline"
        :class="{ 'pg-edit-form-tool__menu--active': menuActive === 'component' }"
        @click="menuChange('component')"
        title="组件"
      ></i>
      <i
        class="el-icon-tickets"
        :class="{ 'pg-edit-form-tool__menu--active': menuActive === 'form' }"
        @click="menuChange('form')"
        title="表单定义"
      ></i>
    </div>
    <PgComponentSelect
      class="pg-edit-form-tool__component"
      v-show="menuActive === 'component'"
    ></PgComponentSelect>
    <PgFormSelect
      class="pg-edit-form-tool__form-select"
      v-show="menuActive === 'form'"
    ></PgFormSelect>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import PgComponentSelect from './component-select.vue'
import PgFormSelect from './form-select.vue'

const menuActive = ref('component')
const menuChange = (val) => {
  menuActive.value = val
}
</script>
<style lang="scss">
@import '../style/edit-form-tool.scss';
</style>
